module.exports = __webpack_public_path__ + "img/commit.88f55596.png";